import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSubscriptionOverride, updateTenantSubscriptionAllocation } from '@/api/promote';
import type { SubscriptionOverridePayload } from '@/types/promote';

export function useSubscriptionOverride(accountId: string, tenantId?: string) {
  const queryClient = useQueryClient();

  return useMutation<void, Error, SubscriptionOverridePayload>({
    mutationFn: async (body: SubscriptionOverridePayload) => {
      if (tenantId) {
        await updateTenantSubscriptionAllocation(accountId, tenantId, body);
        return;
      }
      await updateSubscriptionOverride(accountId, body);
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['crm', 'account', accountId, 'tenant-subscription'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['crm', 'account', accountId, 'tenants'],
        }),
        tenantId
          ? queryClient.invalidateQueries({
              queryKey: ['crm', 'account', accountId, 'tenants', tenantId, 'subscription'],
            })
          : Promise.resolve(),
        queryClient.invalidateQueries({ queryKey: ['crm', 'account', accountId] }),
        queryClient.invalidateQueries({ queryKey: ['crm', 'accounts'] }),
      ]);
    },
  });
}
